var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 159,
    viewBox: "0 0 142 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81024 107.45C2.11965 107.821 2.41647 108.204 2.7 108.6C5.7 102.3 11.8 98.0996 18.7 98.0996C25.1 98.0996 30.8 101.8 34 107.3C36.1 104.5 39.4 102.7 43 102.7C47.5 102.7 51.4 105.5 53.4 109.6C58.6 101.8 67 96.6996 76.5 96.6996C85.5 96.6996 93.6 101.3 98.8 108.4C101.3 103 106.4 99.2996 112.4 99.2996C118.5 99.2996 123.7 103.2 126.2 108.8C128.4 105.9 131.7 104.1 135.5 104.1C137.429 104.1 139.265 104.595 140.898 105.483C141.361 102.222 141.6 98.8888 141.6 95.4996C141.6 56.6188 110.081 25.0996 71.2 25.0996C32.3192 25.0996 0.800049 56.6188 0.800049 95.4996C0.800049 99.5732 1.14604 103.566 1.81024 107.45Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.5 108C66.2421 108 62 112.27 62 117.562C62 131.335 71.5 140.356 71.5 159C71.5 140.356 81 131.335 81 117.562C81 112.33 76.7579 108 71.5 108Z",
    fill: "#E9F4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 115C67.9159 115 65 117.873 65 121.405C65 130.563 71.5 136.609 71.5 149C71.5 136.609 78 130.563 78 121.405C78 117.873 75.0841 115 71.5 115Z",
    fill: "#E4F2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1001 120.299L60.2 120.199C59.2 120.199 58.3 119.399 58.3 118.299V114.199L84 114.299V118.399C84 119.399 83.1001 120.299 82.1001 120.299Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98 77.7988L112.1 97.6988C113.8 100.099 114.4 103.099 113.7 105.899L107 132.999C106.8 133.899 105.7 134.199 105 133.599L83.7 113.999L98 77.7988Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6001 77.5996L30.3001 97.3996C28.6001 99.7996 28.0001 102.8 28.7001 105.6L35.2001 132.7C35.4001 133.6 36.5001 133.9 37.2001 133.3L58.7001 114L44.6001 77.5996Z",
    fill: "url(#paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6002 0.699219C47.3002 20.4992 33.9002 82.9992 53.4002 112.699C54.0002 113.599 54.9002 114.199 55.9002 114.199L86.2001 114.399C87.2001 114.399 88.1002 113.899 88.7001 112.899C108.6 83.2992 95.7001 20.6992 71.6002 0.699219Z",
    fill: "url(#paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6 0.699219C62.8 7.79922 55.5 20.5992 50.6 35.2992C42.8 34.8992 92.3001 35.4992 92.3001 35.4992C87.5001 20.6992 80.3 7.89922 71.6 0.699219Z",
    fill: "url(#paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3 74.8984C79.032 74.8984 85.3 68.6304 85.3 60.8984C85.3 53.1665 79.032 46.8984 71.3 46.8984C63.5681 46.8984 57.3 53.1665 57.3 60.8984C57.3 68.6304 63.5681 74.8984 71.3 74.8984Z",
    fill: "url(#paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5001 59.1975C83.4001 65.3975 79.2001 71.0975 73.0001 72.0975C66.8001 72.9975 61.1001 68.7975 60.1001 62.5975C59.2001 56.3975 63.4001 50.6975 69.6001 49.6975C75.9001 48.7975 81.6001 52.9975 82.5001 59.1975Z",
    fill: "url(#paint7_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 59.1977C82.1 56.5977 80.8 54.2977 79.1 52.5977C79.1 52.8977 79.1 53.1977 79.2 53.4977C79.4 54.8977 79.7 56.2977 79.3 57.6977C78.9 58.8977 77.9 59.9977 76.7 60.3977C75 60.9977 72.9 60.4977 71.2 61.1977C69.1 62.0977 68.3 64.6977 66.2 65.6977C65.2 66.1977 64.1 66.1977 63.1 65.9977C62.4 65.8977 61.6 65.6977 61 65.1977C63 69.7977 67.9 72.6977 73.1 71.8977C79.2 71.1977 83.5 65.3977 82.5 59.1977Z",
    fill: "url(#paint8_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M71.7002 51.498C71.5002 51.498 71.2002 51.498 71.0002 51.498C70.7002 51.498 70.5002 51.598 70.4002 51.798C70.2002 51.998 70.2002 52.198 70.2002 52.498C70.2002 52.998 70.6002 53.398 71.1002 53.398H71.2002C71.4002 53.398 71.6002 53.398 71.8002 53.398C72.1002 53.398 72.3002 53.298 72.5002 53.098C72.7002 52.898 72.8002 52.698 72.8002 52.398C72.6002 51.898 72.2002 51.498 71.7002 51.498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M68.5002 52.0984C68.3002 51.9984 68.0002 51.9984 67.8002 52.0984C65.4002 53.0984 63.5002 54.9984 62.5002 57.3984C62.3002 57.8984 62.6002 58.3984 63.0002 58.5984C63.1002 58.5984 63.2002 58.6984 63.3002 58.6984C63.7002 58.6984 64.0002 58.4984 64.2002 58.0984C65.0002 56.0984 66.5002 54.5984 68.4002 53.7984C68.6002 53.6984 68.8002 53.4984 68.9002 53.2984C69.0002 53.0984 69.0002 52.7984 68.9002 52.5984C68.9002 52.3984 68.8002 52.1984 68.5002 52.0984Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8 107.5C54.5 109.7 55.3 112 56.1 114.2H69.4C69.2 113.8 68.9 113.4 68.7 113.1C68.1 112.1 67.6 111.1 67.1 110.1C66 108.1 65.1 106 64.1 103.8C62.3 99.4996 60.8 95.0996 59.6 90.4996C57.2 81.3996 56 71.8996 56 62.2996C56.1 57.4996 56.3 52.6996 57 47.8996L57.2 46.0996L57.5 44.2996L58.1 40.6996L58.9 37.0996L59.3 35.2996L59.8 33.4996C62.2 24.0996 65.8 14.8996 70.1 6.09961C64.8 14.3996 60.3 23.2996 56.8 32.5996L56.1 34.2996L55.5 36.0996L54.3 39.6996L53.3 43.2996L52.8 45.0996L52.4 46.8996C51.2 51.7996 50.4 56.6996 49.8 61.7996C48.6 71.7996 48.9 82.0996 50.4 92.2996C51.2 97.3996 52.3 102.5 53.8 107.5Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0001 140.099C68.8001 140.099 67.1001 138.299 67.0001 136.199L66.6 109.099C66.5 105.799 66.8001 102.399 67.5001 99.0992L70.1 85.6992H72.4001L74.9001 99.0992C75.5001 102.399 75.8 105.699 75.7 109.099L75.1 136.199C75 138.399 73.2001 140.099 71.0001 140.099Z",
    fill: "url(#paint9_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1001 137.799C61.1001 138.099 60.9001 138.299 60.6001 138.299C60.3001 138.299 60.1001 138.099 60.1001 137.799C60.1001 137.499 60.3001 137.299 60.6001 137.299C60.8001 137.299 61.1001 137.499 61.1001 137.799Z",
    fill: "url(#paint10_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2 71.8992C93.2 72.2992 92.9 72.5992 92.5 72.5992C92.1 72.5992 91.8 72.2992 91.8 71.8992C91.8 71.4992 92.1 71.1992 92.5 71.1992C92.8 71.1992 93.2 71.4992 93.2 71.8992Z",
    fill: "url(#paint11_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7 109.899C74.7 110.199 74.4 110.499 74.1 110.499C73.8 110.499 73.5 110.199 73.5 109.899C73.5 109.599 73.8 109.299 74.1 109.299C74.4 109.299 74.7 109.599 74.7 109.899Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 61.2988C123.5 62.6988 122.4 63.7988 121 63.7988C119.6 63.7988 118.5 62.6988 118.5 61.2988C118.5 59.8988 119.6 58.7988 121 58.7988C122.4 58.7988 123.5 59.8988 123.5 61.2988Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7 72.8984C23.7 74.2984 22.6 75.3984 21.2 75.3984C19.8 75.3984 18.7 74.2984 18.7 72.8984C18.7 71.4984 19.8 70.3984 21.2 70.3984C22.5 70.3984 23.7 71.4984 23.7 72.8984Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M133.6 87.2984C133.6 87.7984 133.2 88.1984 132.7 88.1984C132.2 88.1984 131.8 87.7984 131.8 87.2984C131.8 86.7984 132.2 86.3984 132.7 86.3984C133.2 86.3984 133.6 86.7984 133.6 87.2984Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1001 130.898C45.1001 131.698 44.4001 132.398 43.6001 132.398C42.8001 132.398 42.1001 131.698 42.1001 130.898C42.1001 130.098 42.8001 129.398 43.6001 129.398C44.5001 129.398 45.1001 130.098 45.1001 130.898Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6001 112.6C16.6001 114 15.5001 115.1 14.1001 115.1C12.7001 115.1 11.6001 114 11.6001 112.6C11.6001 111.2 12.7001 110.1 14.1001 110.1C15.5001 110.1 16.6001 111.2 16.6001 112.6Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.844849,
    y1: 95.4662,
    x2: 141.563,
    y2: 95.4662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.088831,
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4104,
    stopColor: "#1D4DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#0F38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 71.1601,
    y1: 120.256,
    x2: 71.1602,
    y2: 114.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5153,
    stopColor: "#C6DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8188,
    stopColor: "#ACD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 83.691,
    y1: 105.801,
    x2: 113.999,
    y2: 105.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC7200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4985,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDD661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 28.3782,
    y1: 105.613,
    x2: 58.6156,
    y2: 105.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 38.9766,
    y1: 33.0283,
    x2: 103.847,
    y2: 97.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2088,
    stopColor: "#FBFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#EFF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6226,
    stopColor: "#DBEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8275,
    stopColor: "#BFDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 57.4567,
    y1: 14.5493,
    x2: 85.3302,
    y2: 42.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 61.5152,
    y1: 50.9527,
    x2: 81.1773,
    y2: 70.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833177,
    stopColor: "#FCC019"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4305,
    stopColor: "#FDA729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7462,
    stopColor: "#FD9732"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD9235"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 63.3427,
    y1: 52.8796,
    x2: 79.3501,
    y2: 68.8881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2559CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3525,
    stopColor: "#2255CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6915,
    stopColor: "#1B4AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F38C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 68.392,
    y1: 57.9289,
    x2: 79.3505,
    y2: 68.8881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F38C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3481,
    stopColor: "#143FC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8476,
    stopColor: "#2052CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2559CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 56.9385,
    y1: 98.9129,
    x2: 85.4092,
    y2: 127.383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5015,
    stopColor: "#FCA22E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC7200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 60.0263,
    y1: 137.833,
    x2: 61.074,
    y2: 137.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE9F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 91.6684,
    y1: 71.9203,
    x2: 93.1651,
    y2: 71.9203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE9F5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketDashboard);
export default __webpack_public_path__ + "static/media/RocketDashboard.4c2d4c5f.svg";
export { ForwardRef as ReactComponent };